import downtimeService from '@nuskin/ns-util/src/downtimeService';
import {CartService} from '@nuskin/ns-shop';

export default {
    methods: {
        async checkDownTime() {
            try {
                const downTimeResult = await downtimeService.getDowntimeStatus();
                if (downTimeResult.isDown) {
                    CartService.goToCheckoutPage({route: 'downtime'});
                }
            } catch (error) {
                console.log(error);
            }
        }
    }
};
